export default {
  corporate: require('./corporate').default,
  personal: require('./personal').default,
  transactions: require('./transactions').default,
};
